(() => {
  const config = document.currentScript.dataset;
  let pending;

  function showStatus(container, failed = false) {
    const footer = container.querySelector('.drawer__footer, .cart__footer');
    if (!footer) return;
    let status = footer.querySelector('[data-shipping-status]');
    if (!status) {
      status = document.createElement('div');
      status.dataset.shippingStatus = '';
      status.setAttribute('role', 'status');
      footer.prepend(status);
    }
    status.textContent = failed ? config.error : config.loading;
    if (failed) {
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'link underlined-link';
      retry.textContent = config.retry;
      retry.addEventListener('click', () => activate(container), { once: true });
      status.append(' ', retry);
    }
  }

  function load() {
    if (window.cartShippingCalculatorProAppLoaded) return Promise.resolve();
    if (pending) return pending;
    // The vendor checks this installation flag, initializes immediately, and
    // loads its own stylesheet/options. It does not depend on DOMContentLoaded.
    window.cartShippingCalculatorProAppBlock = true;
    pending = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://d1an1e2qw504lz.cloudfront.net/shop/js/cart-shipping-calculator-pro.min.js?shop=${encodeURIComponent(config.shop)}`;
      script.async = true;
      script.onload = resolve;
      script.onerror = () => {
        script.remove();
        pending = undefined;
        reject(new Error('Shipping calculator could not be loaded'));
      };
      document.head.append(script);
    });
    return pending;
  }

  function activate(container) {
    showStatus(container);
    load().then(() => {
      container.querySelectorAll('[data-shipping-status]').forEach(node => node.remove());
      // The vendor also watches cart changes and newly replaced cart markup.
      window.cartShippingCalculatorProApp?.updateWidgets?.();
    }).catch(() => showStatus(container, true));
  }

  document.addEventListener('cart:drawer-open', event => activate(event.target));
  if (config.cartPage === 'true') activate(document);
  document.addEventListener('shopify:section:load', () => {
    if (config.cartPage === 'true') activate(document);
  });
})();
